import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {AutologinService} from '../services/autologin.service';
import {CookieService} from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class LoggedGuard implements CanActivate {
  /**
   *
   */
  constructor(
    private cookies: CookieService,
    private autologin: AutologinService,
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    try {
      if (route.params.token) {
        console.log('pasa por aca', route.params.token);
        this.autologin.setToken(route.params.token);
        console.log(route, 'ruta');
        // this.router.navigate([route.url[0].path]);
        return true;
      } else {
        if (!this.autologin.checkToken()) {
          this.router.navigate(['/login']);
          return false;
        }
      }
    } catch (error) {}

    return true;
  }
}
